import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import ITextBuilder from "../../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import IClubSelectorBuilder from "../../../../toolkit/baseForms2Commons/iClubSelectorBuilder/IClubSelectorBuilder";

export type ActualizarSnapshotInputs =
  | "modo"
  | "observaciones"
  | "idClubModificado"
  | "precioVentaModificado";
export type ActualizarSnapshotButtons = "aceptar" | "cancelar";

export const gestionFormConfig: FormBuilderConfig<
  ActualizarSnapshotInputs,
  ActualizarSnapshotButtons
> = {
  inputs: [
    {
      name: "modo",
      label: "* Modalidad",
      bts: { mCol: 12 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Seleccione...",
        data: [
          { value: "DEFAULT", label: "Estándar (determinado por el sistema)" },
          {
            value: "ALCANCE_INDIVIDUAL",
            label: "Solo Alcance Individual, sin pago"
          },
          { value: "ALCANCE_CLUB", label: "Solo Alcance de Club" },
          { value: "ALCANCE_REGIONAL", label: "Solo Alcance Regional" },
          { value: "DESCARTADA", label: "Descartada, sin Alcance ni pago" }
        ]
      }
    },
    {
      name: "observaciones",
      label: "* Observaciones",
      bts: { mCol: 12 },
      component: ITextBuilder,
      props: {
        maxlength: 500
      }
    },
    {
      name: "idClubModificado",
      label: "Club Modificado",
      bts: { mCol: 12 },
      component: IClubSelectorBuilder
    },
    {
      name: "precioVentaModificado",
      label: "Precio Venta Modificado",
      bts: { mCol: 12 },
      component: ITextBuilder,
      props: {
        type: "NUMERIC"
      }
    }
  ],
  buttons: [
    {
      name: "aceptar",
      label: "Guardar",
      isSubmit: true,
      bts: { mCol: 6 },
      component: IButtonBuilder
    },
    {
      name: "cancelar",
      label: "Cancelar",
      isSubmit: false,
      bts: { mCol: 6 },
      component: IButtonBuilder
    }
  ],
  validations: {
    modo: {
      required: true
    },
    observaciones: {
      required: true
    }
  },
  rows: [
    ["modo"],
    ["idClubModificado"],
    ["precioVentaModificado"],
    ["observaciones"],
    ["aceptar", "cancelar"]
  ]
};
